"use client";

import React from "react";

type Item = { value: string; label: string };

interface ScrollablePillsProps {
  items: Item[];
  value: string;
  onChange: (v: string) => void;
  className?: string;
}

export function ScrollablePills({ items, value, onChange, className }: ScrollablePillsProps) {
  return (
    <div className={"relative " + (className || "")}>
      {/* Custom scrollable container - break out of parent constraints */}
      <div
        className="overflow-x-auto overflow-y-hidden sm:overflow-x-visible"
        style={{
          width: 'calc(100vw - 24px)',
          marginLeft: 'calc(-1 * (100vw - 100%) / 2 - 12px)',
          marginRight: 'calc(-1 * (100vw - 100%) / 2 - 12px)',
          paddingLeft: 'calc((100vw - 100%) / 2 + 12px)',
          paddingRight: 'calc((100vw - 100%) / 2 + 12px)',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        <div
          role="tablist"
          aria-label="Categories"
          className="inline-flex gap-2 pb-1 sm:flex sm:flex-wrap"
          style={{
            minWidth: 'max-content'
          }}
        >
          {items.map((item) => {
            const selected = item.value === value;
            return (
              <button
                key={item.value}
                role="tab"
                aria-selected={selected}
                onClick={() => onChange(item.value)}
                className={`font-normal rounded-full py-2 px-4 text-sm transition-all duration-200 whitespace-nowrap flex-shrink-0 ${
                  selected
                    ? "bg-accent-foreground text-secondary"
                    : "bg-primary/20 text-foreground hover:bg-primary/30"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Mobile scroll indicators */}
      <div className="absolute right-0 top-0 bottom-0 w-6 bg-gradient-to-l from-background to-transparent pointer-events-none sm:hidden z-10"></div>
      <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-background to-transparent pointer-events-none sm:hidden z-10"></div>

      {/* Hide scrollbar */}
      <style jsx>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}

